import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

let Bar

const ProductAnalyticsCompetitionChart = ({ data, labels }) => {
  const [isLoaded, setIsLoaded] = useState()

  useEffect(() => {
    import('react-chartjs-2').then(module => {
      Bar = module.Bar
      setIsLoaded(true)
    })
  }, [])

  if (!isLoaded) return null

  const chartConfiguration = {
    data: {
      labels,
      datasets: [
        {
          label: 'Number of models',
          data,
          backgroundColor: 'rgba(103, 196, 176, 0.8)',
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{ display: false }],
      },
      legend: {
        onClick: (e) => e.stopPropagation(),
      },
      tooltips: {
        enabled: false,
      },
    },
  }

  return (
    <div className="chart-container">
      <div className="chart-container__description">
        <h3>Competition</h3>
        <p>
          The number of models in each category which means the competition. Larger volume indicates greater
          competition.
        </p>
      </div>

      <div className="chart-container__chart">
        <Bar redraw data={chartConfiguration.data} options={chartConfiguration.options} />
      </div>
    </div>
  )
}

ProductAnalyticsCompetitionChart.propTypes = {
  data: PropTypes.array,
  labels: PropTypes.array,
}

ProductAnalyticsCompetitionChart.defaultPropTypes = {
  data: [],
  labels: [],
}

export default ProductAnalyticsCompetitionChart
